import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetGuestSiteScheduleCTASessionFragment = {
  __typename?: 'EventSession';
  id: string;
  hasUnlocked: boolean;
  eventCTA: { __typename?: 'EventSessionCTA'; scheduleHasInviteOnlyItems: boolean };
  person?: { __typename?: 'Person'; id: string; fullName?: string | null } | null;
};

export type GetGuestSiteScheduleQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
  isAdmin?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;

export type GetGuestSiteScheduleQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    activeSession: {
      __typename?: 'EventSession';
      id: string;
      hasUnlocked: boolean;
      eventCTA: { __typename?: 'EventSessionCTA'; scheduleHasInviteOnlyItems: boolean };
      person?: { __typename?: 'Person'; id: string; fullName?: string | null } | null;
    };
    info: {
      __typename?: 'EventInfo';
      id: string;
      schedule: {
        __typename?: 'EventScheduleInfo';
        id: string;
        formattedSchedules: Array<{
          __typename?: 'FormattedSchedule';
          id: string;
          date: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number; hostTimeString: string; hostDateString: string };
          items: Array<{
            __typename?: 'EventSchedule';
            id: string;
            description?: string | null;
            dressCode?: string | null;
            isMain: boolean;
            isPublic: boolean;
            location?: string | null;
            name: string;
            placeId?: string | null;
            showMap: boolean;
            timezone?: string | null;
            unplugged: boolean;
            endTime?: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number; hostTimeString: string; hostDateString: string } | null;
            locationInfo?: { __typename?: 'EventLocation'; id?: string | null; latitude?: number | null; longitude?: number | null } | null;
            startTime?: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number; hostTimeString: string; hostDateString: string } | null;
            virtualEventLink?: {
              __typename?: 'VirtualEventLinkParseResult';
              provider: Types.VirtualEventProvider;
              linkText: string;
              isLinkValid: boolean;
              isPasswordDetected: boolean;
              passwordText?: string | null;
              passwordUrlEmbed?: string | null;
              streamId?: string | null;
              urlLinkText?: string | null;
              urlApp?: string | null;
              urlBrowser?: string | null;
            } | null;
          }>;
        }>;
        toBeAnnouncedItems: Array<{
          __typename?: 'EventSchedule';
          id: string;
          description?: string | null;
          dressCode?: string | null;
          isMain: boolean;
          isPublic: boolean;
          location?: string | null;
          name: string;
          placeId?: string | null;
          showMap: boolean;
          timezone?: string | null;
          unplugged: boolean;
          endTime?: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number; hostTimeString: string; hostDateString: string } | null;
          locationInfo?: { __typename?: 'EventLocation'; id?: string | null; latitude?: number | null; longitude?: number | null } | null;
          startTime?: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number; hostTimeString: string; hostDateString: string } | null;
          virtualEventLink?: {
            __typename?: 'VirtualEventLinkParseResult';
            provider: Types.VirtualEventProvider;
            linkText: string;
            isLinkValid: boolean;
            isPasswordDetected: boolean;
            passwordText?: string | null;
            passwordUrlEmbed?: string | null;
            streamId?: string | null;
            urlLinkText?: string | null;
            urlApp?: string | null;
            urlBrowser?: string | null;
          } | null;
        }>;
      };
    };
  } | null;
};

export const GetGuestSiteScheduleCTASessionFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GetGuestSiteScheduleCTASession' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventSession' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasUnlocked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventCTA' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'scheduleHasInviteOnlyItems' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'person' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetGuestSiteScheduleDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetGuestSiteSchedule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isAdmin' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeSession' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'GetGuestSiteScheduleCTASession' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'isAdmin' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'schedule' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'formattedSchedules' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'FormattedEventSchedule' } }] },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'toBeAnnouncedItems' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventSchedule' } }] },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GetGuestSiteScheduleCTASession' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventSession' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasUnlocked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventCTA' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'scheduleHasInviteOnlyItems' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'person' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FormattedEventSchedule' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FormattedSchedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'date' },
            name: { kind: 'Name', value: 'dateV0918' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TimezoneDate' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventSchedule' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TimezoneDate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'hostTimeString' },
            name: { kind: 'Name', value: 'dateString' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'timeFormat' }, value: { kind: 'EnumValue', value: 'time' } }],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'hostDateString' },
            name: { kind: 'Name', value: 'dateString' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventSchedule' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventSchedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dressCode' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'endTime' },
            name: { kind: 'Name', value: 'endTimeV0918' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TimezoneDate' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isMain' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'showMap' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'startTime' },
            name: { kind: 'Name', value: 'startTimeV0918' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TimezoneDate' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unplugged' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virtualEventLink' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'VirtualEventLinkParseResult' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VirtualEventLinkParseResult' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VirtualEventLinkParseResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLinkValid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPasswordDetected' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passwordUrlEmbed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streamId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'urlLinkText' } },
          { kind: 'Field', name: { kind: 'Name', value: 'urlApp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'urlBrowser' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetGuestSiteScheduleQuery__
 *
 * To run a query within a React component, call `useGetGuestSiteScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestSiteScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestSiteScheduleQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useGetGuestSiteScheduleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestSiteScheduleQuery, GetGuestSiteScheduleQueryVariables>) {
  return ApolloReactHooks.useQuery<GetGuestSiteScheduleQuery, GetGuestSiteScheduleQueryVariables>(GetGuestSiteScheduleDocument, baseOptions);
}
export function useGetGuestSiteScheduleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestSiteScheduleQuery, GetGuestSiteScheduleQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetGuestSiteScheduleQuery, GetGuestSiteScheduleQueryVariables>(GetGuestSiteScheduleDocument, baseOptions);
}
export type GetGuestSiteScheduleQueryHookResult = ReturnType<typeof useGetGuestSiteScheduleQuery>;
export type GetGuestSiteScheduleLazyQueryHookResult = ReturnType<typeof useGetGuestSiteScheduleLazyQuery>;
export type GetGuestSiteScheduleQueryResult = Apollo.QueryResult<GetGuestSiteScheduleQuery, GetGuestSiteScheduleQueryVariables>;
